<template>
  <div v-if="isClient" class="pt-5 pb-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <h2 class="font-32 blue-color font-bold text-center">
            {{ $t("home_client.recommendations.title") }}
          </h2>

          <div class="row mt-5 justify-content-center align-items-center">
            <div class="col-lg-4">
              <div class="d-flex flex-column justify-content-center gap-3 align-items-center">
                <img :src="support" class="w-30" />
                <p class="text-center font-bold blue-color">
                  {{ $t("home_client.recommendations.features.customer_service") }}
                </p>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="d-flex flex-column justify-content-center gap-3 align-items-center">
                <img :src="pays" class="w-30" />
                <p class="text-center font-bold blue-color">
                  {{ $t("home_client.recommendations.features.made_in_france") }}
                </p>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="d-flex flex-column justify-content-center gap-3 align-items-center">
                <img :src="deliveryClient" class="w-30" />
                <p class="text-center font-bold blue-color">
                  {{ $t("home_client.recommendations.features.delivery") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-else class="service row">
    <h2 class="text-center title-service mb-0">{{ $t("service_component.title") }}</h2>

    <p class="text-center">{{ $t("service_component.description") }}</p>
    <div class="row mt-4 content justify-content-center">
      <div class="col-lg-10">
        <div class="service-grid">
          <div class="service-item text-center">
            <img :src="service1" class="service-icon" />
            <p
              class="mt-2 text-center short-desc"
              v-html="$sanitize.sanitizeI18nContent($t('service_component.items.access_ranges'))"
            ></p>
          </div>
          <div class="service-item text-center">
            <img :src="delivery" class="service-icon bg-round" />
            <p
              class="mt-2 text-center short-desc"
              v-html="$sanitize.sanitizeI18nContent($t('service_component.items.delivery_time'))"
            ></p>
          </div>
          <div class="service-item text-center">
            <img :src="platform" class="service-icon bg-round" />
            <p
              class="mt-2 text-center short-desc"
              v-html="$sanitize.sanitizeI18nContent($t('service_component.items.all_tools_platform'))"
            ></p>
          </div>
          <div class="service-item text-center">
            <img :src="callcenter" class="service-icon bg-round" />
            <p
              class="mt-2 text-center short-desc"
              v-html="$sanitize.sanitizeI18nContent($t('service_component.items.customer_service'))"
            ></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import support from "@/assets/images/support.svg";
  import pays from "@/assets/images/pays.svg";
  import service1 from "../assets/service-1.png";
  import deliveryClient from "@/assets/images/delivery.svg";
  import delivery from "../assets/delivery_ico.png";
  import platform from "../assets/platform.png";
  import callcenter from "../assets/call-center.png";
import { useRegisterStore } from '@/stores/register';
  export default {
    name: "ServiceList",
    data() {
      return {
        service1,
        delivery,
        platform,
        callcenter,
        support,
        pays,
        deliveryClient,
        registerStore: useRegisterStore(),
      };
    },

    computed: {
      isClient() {
        return this.registerStore.user?.role === "client";
      },
    },
  };
</script>

<style scoped>
  .service {
    gap: 10px;
    margin-top: 20px;
    justify-content: center;
  }

  .title-service {
    color: #1e347d;
    font-weight: 900;
    line-height: 55px;
    font-size: 45px;
    font-style: normal;
    justify-content: center;
  }

  .service .short-desc {
    color: #1e347d;
    font-size: 16px;
    font-weight: bold;
  }

  .service-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    width: 100%;
  }

  .service-item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .service-icon {
    width: 86px;
    height: 86px;
    object-fit: contain;
  }

  img.bg-round {
    background: #1e347d;
    border-radius: 50%;
    padding: 25px;
  }

  @media (max-width: 768px) {
    .title-service {
      font-size: 17px;
      line-height: 30px;
    }
  }

  /* Styles pour tablette */
  @media (max-width: 992px) {
    .service-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 30px;
    }
    
    .service-icon {
      width: 70px;
      height: 70px;
    }
    
    img.bg-round {
      padding: 20px;
    }
    
    .service .short-desc {
      font-size: 14px;
    }
  }

  /* Styles pour mobile - Affichage en liste */
  @media (max-width: 600px) {
    .service {
      margin-top: 15px;
      gap: 8px;
    }
    
    .title-service {
      font-size: 22px;
      line-height: 28px;
      margin-bottom: 10px;
    }
    
    .service .short-desc {
      font-size: 13px;
      line-height: 1.3;
    }
    
    .service-grid {
      grid-template-columns: 1fr;
      gap: 20px;
    }
    
    .service-item {
      flex-direction: column;
      text-align: left;
      gap: 15px;
      align-items: center;
      padding: 12px;
      background: #f8f9fa;
      border-radius: 12px;
      border: 1px solid #e9ecef;
    }
    
    .service-icon {
      width: 50px;
      height: 50px;
      flex-shrink: 0;
    }
    
    img.bg-round {
      padding: 12px;
      background: #1e347d;
    }
    
    .service-item .short-desc {
      margin-top: 0 !important;
      text-align: left;
      flex: 1;
    }
  }

  /* Styles pour très petits écrans */
  @media (max-width: 480px) {
    .service {
      margin-top: 10px;
      gap: 6px;
    }
    
    .title-service {
      font-size: 20px;
      line-height: 24px;
    }
    
    .service-item {
      gap: 12px;
      padding: 10px;
    }
    
    .service-icon {
      width: 45px;
      height: 45px;
    }
    
    img.bg-round {
      padding: 10px;
    }
    
    .service .short-desc {
      font-size: 12px;
    }
    
    .service-grid {
      gap: 15px;
    }
  }
</style>